import React, { useEffect, useState } from 'react';
import {
    DownOutlined,
    UpOutlined,
  } from "@ant-design/icons";
import styles from "../../../MenuSection//style.module.scss";
import samplesec from "../../../../assets/images/samplesec.png";
import { message, Switch } from 'antd';
import IngredientsService from "../../../../services/IngredientsService";


const ItemList = (props) => {
    const { setExpandId, expandId } = props;
    const [menuGroups, setMenuGroups] = useState([]);

    const getMenuItems = () => {
      IngredientsService.getMenuGroups(props.adminRestaurant).then((res)=>{
            setMenuGroups(res.menu_groups);
        });
    };
    useEffect(()=>{
        getMenuItems();
    }, [props.adminRestaurant]);
    const onIngredient = (e, field) =>{
      IngredientsService.updateMenuItem(field.id).then((res)=>{
        if(res){
          getMenuItems();
          message.success("Updated successfully");
        }
      })
    };
    return <>{
      menuGroups.map((item)=>{
        return <div className={styles.card_wrap} style={{marginBottom: 10 }}>
        <div className={styles.head_card} onClick={() => {item.id === expandId ? setExpandId("") : setExpandId(item.id) }} style={{paddingRight: 30 }}>
          <div className={styles.img_sec}>
            <div className={styles.sec_imgholder}>
              <img src={samplesec} style={{ height: "inherit" }} alt="" />
            </div>
            <span className={styles.sec_name}>{item.name}</span>
          </div>
          {item.id === expandId ? (
              <DownOutlined
                onClick={() => {
                  setExpandId("");
                }}
              />
            ) : (
              <UpOutlined
                onClick={() => {
                  setExpandId(item.id);
                }}
              />
            )}
        </div>
        {expandId === item.id && <> 
            <div className={styles.item_details}>
              {
                item.menu_items?.map((field)=>{
                  return <div className={styles.action_switch}>
                  <span><Switch checked={field.is_active} onChange={(e)=>{onIngredient(e, field)}} /></span>
                  <label>{field.name}</label>
                  </div>
                })
              }
              {item.menu_items?.length < 1 &&<div style={{ textAlign: 'center', width: '100%', opacity: .5}}>No items added</div>}
            </div>
        </>}
        </div>
      })
    }
    </> 
};
export default ItemList;